<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>

        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">                
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="filters.brand_id"
                            :items="brands"
                            label="Seleccione marca"
                            hide-details
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="filters.name" label="Nombre" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="filters.description"
                            outlined
                            label="Descripción"
                            >
                        </v-textarea>
                    </v-col>
                </v-row>
            </template>                    
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn block height="40" dark color="red" @click="handleClearFilters">
                            <v-icon size="16" class="mr-1">far fa-trash-alt</v-icon>
                            Quitar filtros
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn dark color="blue" block height="40" @click="handleSearch">
                            <v-icon size="16" class="mr-1">fas fa-search</v-icon>
                            Filtrar datos
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions} from 'vuex'

export default {
    name: 'Filters',
    data() {
        return {
            drawer: false,
            titleForm: null,
            filters: {
                name: null,
                description: null,
                brand_id: null
            }
        }
    },
    computed: {
        ...mapState('brands', [
            'brands'
        ])
    },
    methods: {
        ...mapActions('brands', [
            'getBrands',
        ]),
        ...mapActions('types', [
            'getTypes'
        ]),
        showForm(title) {
            this.titleForm = title
            this.drawer = !this.drawer
        },
        closeForm() {
            this.drawer = false
        },
        clearData() {
            this.filters.description = null
            this.filters.brand_id = null
        },
        customText(item){
            let text = item.name
            
            return text
        },
        async handleClearFilters() {
            this.clearData()
            await this.getTypes(this.filters)
        },
        async handleSearch() {
            await this.getTypes(this.filters)
            this.closeForm()
        }
    },
    mounted() {
        this.getBrands()
    }
}
</script>

<style scoped>

</style>